<template>
  <div class="app-container">
    <!-- 顶部导航栏 -->
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="first"></el-tab-pane>
        <el-tab-pane label="欠费公司" name="second"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 筛选 -->
    <div class="top_btns clearfix">
      <div class="left_search fl">
        <el-input placeholder="请输入公司名称或联系人" v-model="listQuery.name" style="width: 200px;margin-right:10px" size="mini" />
        <el-button class="filter-item" type="primary" @click="getList" size="mini" plain>搜索</el-button>
        <el-select size="mini" v-model="listQuery.status" @change="getList" filterable placeholder="请选择">
          <el-option key="0" label="全部" :value="0"></el-option>
          <el-option key="1" label="正常使用" :value="1"></el-option>
          <el-option key="2" label="试用" :value="2"></el-option>
          <el-option key="3" label="停用" :value="3"></el-option>
        </el-select>
      </div>
      <div class="right_btns fr">
        <el-button @click="migration()" type="success" size="mini" plain>迁移</el-button>
        <el-button @click="handleCreate()" type="primary" size="mini" plain>新增</el-button>
        <el-button @click="daochu()" type="info" size="mini" plain>导出</el-button>
        <!-- <el-button @click="handleApply()" type="success" size="mini" plain>试用列表</el-button> -->
      </div>
    </div>

    <!-- table -->
    <el-table :height="contentStyleObj" :data="list" border fit highlight-current-row style="width: 100%;" @selection-change="handleSelectionChange" @sort-change="sortChange" size="mini">
      <!-- <el-table-column type="selection" align="center"/> -->
      <el-table-column label="序号" align="center" width="55" type="index">
      </el-table-column>

      <el-table-column label="时间" align="center" min-width="100">
        <template #default="scope">
          <span>{{  $parseTime(scope.row.createdAt, "{y}-{m}-{d}") }}</span>
        </template>
      </el-table-column>
      <el-table-column label="集团名称" align="center" min-width="200">
        <template #default="scope">
          <!-- <el-input v-model="scope.row.groupName" style="width:95%"/> -->
          <span>{{scope.row.groupName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="集团账号管理" align="center" min-width="240">
        <template #default="scope">
          <el-button size="mini" type="success" @click="handleGroup(scope.row)" plain>集团账号管理</el-button>
          <el-button size="mini" type="success" @click="handlemod(scope.row)" plain>修改</el-button>
          <el-button size="mini" type="danger" @click="handledel(scope.row)" plain>删除</el-button>
        </template>
      </el-table-column>
     <el-table-column label="公司名" align="center" min-width="200">
        <template #default="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column label="姓名" align="center" min-width="100">
        <template #default="scope">
          <span>{{scope.row.manager}}</span>
        </template>
      </el-table-column>
      <el-table-column label="电话" align="center" min-width="110">
        <template #default="scope">
          <span>{{scope.row.managerTel}}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建人" align="center" min-width="100">
        <template #default="scope">
          <span>{{scope.row.createName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" min-width="90">
        <template #default="scope">
          <div v-if="scope.row.isTrial != 1">
            <span v-if="scope.row.status == 1" style="color:green">正常使用</span>
            <span v-else style="color:red">已停用</span>
          </div>
          <div v-else>
            <span v-if="scope.row.status == 1" style="color:blue">试用</span>
            <span v-else style="color:red">已停用</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="状态" align="center" min-width="90">
        <template #default="scope">
          <span v-if="scope.row.simple != 1" style="color:green">正常版</span>
          <span v-else style="color:blue">简易版</span>
        </template>
      </el-table-column>

      <el-table-column label="账套个数" align="center" min-width="75">
        <template #default="scope">
          <span>{{scope.row.count}}</span>
        </template>
      </el-table-column>
      <el-table-column label="已使用" align="center" min-width="75">
        <template #default="scope">
          <span>{{scope.row.used}}</span>
        </template>
      </el-table-column>

      <el-table-column label="账套启用日期" align="center" min-width="100">
        <template #default="scope">
          <span v-if="!scope.row.countTime.match('0001')">{{$parseTime(scope.row.countTime, "{y}-{m}-{d}")}}</span>
          <!-- <span v-if="scope.row.countTime">{{$parseTime(scope.row.countTime, "{y}-{m}-{d}")}}</span> -->
          <span v-else>暂未设置</span>
        </template>
      </el-table-column>

      <el-table-column label="账套到期日期" align="center" min-width="100">
        <template #default="scope">
          <span>{{scope.row.countUseTime}}</span>
        </template>
      </el-table-column>

      <el-table-column label="所属区域" align="center" min-width="90">
        <template #default="scope">
          <span>{{scope.row.districtName}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" min-width="380" class-name="small-padding fixed-width">
        <template #default="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)" plain>编辑</el-button>
          <el-button size="mini" type="success" @click="handleAdmin(scope.row)" plain>管理员账号</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)" plain>删除</el-button>
          <el-button type="danger" v-if="scope.row.status == 1" size="mini" class="tablebutton" @click="stopStatus(scope.row)" plain>停用</el-button>
          <el-button type="success" v-else size="mini" class="tablebutton" @click="startStatus(scope.row)" plain>启用</el-button>
          <el-button size="mini" type="success" @click="settingCount(scope.row)" plain>设置</el-button>
          <!-- <el-button size="mini" type="primary" @click="settingSupplier(scope.row)" plain>设置为供应商</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <qzf-pagination v-show="total>0" :total="total" v-model:page="listQuery.page" v-model:limit="listQuery.limit" @pagination="getList" />
    </div>

<!-- 新增编辑的弹窗 -->
    <el-dialog destroy-on-close :title="textMap[dialogStatus]" v-model="dialogFormVisible" :close-on-click-modal="false" class="button_bg" width="700px">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="right" label-width="100px" >
        <div class="grid-content bg-purple">
          <el-form-item label="集团名称:" prop="name" size="mini">
            <group v-model:groupId="temp.groupId"></group>
          </el-form-item>
          <el-form-item label="公司名称:" prop="name" size="mini">
            <el-input v-model="temp.name" style="width:95%"/>
          </el-form-item>
          <el-form-item label="负责人:" prop="manager" size="mini">
            <el-input v-model="temp.manager" style="width:95%"/>
          </el-form-item>

          <el-form-item label="负责人手机号:" prop="managerTel" size="mini">
            <el-input v-model="temp.managerTel" style="width:95%"/>
          </el-form-item>

          <el-form-item label="地址:" prop="address" size="mini">
            <el-input v-model="temp.address" style="width:95%"/>
          </el-form-item>

          <el-form-item label="试用用户:" prop="isTrial">
            <el-radio-group v-model="temp.isTrial">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="共享机器人:" prop="robot">
            <el-radio-group v-model="temp.robot">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="简易版:" prop="simple">
            <el-radio-group v-model="temp.simple">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="所属区域:" prop="districtCode" size="mini">
            <selectcity v-model:citys="temp.districtCode"></selectcity>
          </el-form-item>
            
        </div>
      </el-form>
      <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()" size="mini">确定</el-button>
      </span>
    </template>
    </el-dialog>
<!-- 迁移弹窗 -->
    <el-dialog destroy-on-close title="迁移" v-model="dialogFormVisible1" class="button_bg" width="1200px">
      <el-input placeholder="请输入公司名称或联系人" v-model="listQuery1.name" style="width: 200px;margin-right:5px;margin-bottom: 5px;" size="mini" />
      <el-button class="filter-item" type="primary" @click="migration" size="mini" plain>搜索</el-button>
      <el-table :height="contentStyleObj1" :data="list1" border fit highlight-current-row style="width: 100%;" @selection-change="handleSelectionChange" @sort-change="sortChange" size="mini">
        <el-table-column label="序号" align="center" width="55" type="index">
        </el-table-column>
      <el-table-column label="公司名" align="center" min-width="200">
          <template #default="scope">
            <span>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" align="center" min-width="100">
          <template #default="scope">
            <span>{{scope.row.manager}}</span>
          </template>
        </el-table-column>
        <el-table-column label="电话" align="center" min-width="110">
          <template #default="scope">
            <span>{{scope.row.managerTel}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" min-width="90">
          <template #default="scope">
            <div v-if="scope.row.isTrial != 1">
              <span v-if="scope.row.status == 1" style="color:green">正常使用</span>
              <span v-else style="color:red">已停用</span>
            </div>
            <div v-else>
              <span v-if="scope.row.status == 1" style="color:blue">试用</span>
              <span v-else style="color:red">已停用</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center" min-width="90">
          <template #default="scope">
            <span v-if="scope.row.simple != 1" style="color:green">正常版</span>
            <span v-else style="color:blue">简易版</span>
          </template>
        </el-table-column>

        <el-table-column label="账套个数" align="center" min-width="75">
          <template #default="scope">
            <span>{{scope.row.count}}</span>
          </template>
        </el-table-column>

        <el-table-column label="账套启用日期" align="center" min-width="100">
          <template #default="scope">
            <span v-if="!scope.row.countTime.match('0001')">{{$parseTime(scope.row.countTime, "{y}-{m}-{d}")}}</span>
            <span v-else>暂未设置</span>
          </template>
        </el-table-column>

        <el-table-column label="账套到期日期" align="center" min-width="100">
          <template #default="scope">
            <span>{{scope.row.countUseTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="100">
          <template #default="scope">
          <el-button type="primary" size="mini" @click="qianyi(scope.row)" plain>迁移</el-button>
        </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <qzf-pagination v-show="total1>0" :total="total1" v-model:page="listQuery1.page" v-model:limit="listQuery1.limit" @pagination="migration" />
      </div>
    </el-dialog>
<!-- 设置管理员弹窗 -->
    <el-dialog destroy-on-close title="设置管理员账号" v-model="dialogAdminFormVisible" :close-on-click-modal="false" class="button_bg" width="500px">
      <el-form :model="adminTemp" label-position="right" label-width="100px" >
          <el-form-item label="姓名:" prop="name" size="mini">
            <el-input v-model="adminTemp.cnName" style="width:85%"/>
          </el-form-item>

          <el-form-item label="手机号:" prop="manager" size="mini">
            <el-input disabled v-model="adminTemp.mobile" style="width:85%"/>
          </el-form-item>

          <el-form-item label="用户名:" prop="managerTel" size="mini">
            <el-input v-model="adminTemp.userName" style="width:85%"/>
          </el-form-item>

          <el-form-item label="密码:" prop="address" size="mini">
            <el-input disabled v-model="adminTemp.password" style="width:85%"/>
          </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogAdminFormVisible = false" size="mini">取消</el-button>
          <el-button type="primary" @click="adminUpdate" size="mini">确定</el-button>
        </span>
      </template>
    </el-dialog>
<!-- 设置集团账号管理 -->
    <el-dialog destroy-on-close title="设置集团账号管理" v-model="dialogAdminFormVisible1" :close-on-click-modal="false" class="button_bg" width="500px">
      <el-form :model="adminGly" label-position="right" label-width="100px" >
          <el-form-item label="姓名:" prop="name" size="mini">
            <el-input v-model="adminGly.cnName" style="width:85%"/>
          </el-form-item>
          <el-form-item label="用户名:" prop="managerTel" size="mini">
            <el-input v-model="adminGly.userName" style="width:85%"/>
          </el-form-item>
          <el-form-item label="密码:" prop="address" size="mini">
            <el-input v-model="adminGly.password" style="width:85%"/>
          </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogAdminFormVisible1 = false" size="mini">取消</el-button>
          <el-button type="primary" @click="adminUpdateGLY" size="mini">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog destroy-on-close title="修改集团名称" v-model="dialogAdminFormVisible2" :close-on-click-modal="false" class="button_bg" width="500px">
      <el-form :model="adminXG" label-position="right" label-width="100px" >
          <el-form-item label="集团名称:" prop="name" size="mini">
            <el-input v-model="adminXG.name" style="width:85%"/>
          </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogAdminFormVisible2 = false" size="mini">取消</el-button>
          <el-button type="primary" @click="adminUpdateXG" size="mini">确定</el-button>
        </span>
      </template>
    </el-dialog>
<!-- 设置账套个数 -->
    <el-dialog destroy-on-close title="设置账套" v-model="dialogCountFormVisible" :close-on-click-modal="false" class="button_bg" width="400px">
      <el-form :model="countsTemp" label-position="right" label-width="100px" >
        <el-form-item label="账套个数:" prop="count">
          <el-input style="width:220px"  type="number" v-model.number="countsTemp.count" size="mini"/>
        </el-form-item>
        <el-form-item label="启用时间:" prop="countTime" style="width:98%;">
          <el-date-picker v-model="countsTemp.countTime" type="date" placeholder="选择日期" @change="QYSJ" size="mini">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="到期时间:" style="width:98%;">
          <el-date-picker v-model="countsTemp.countUseTime" value-format="YYYY-MM-DD" type="date" placeholder="选择日期" size="mini">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogCountFormVisible = false" size="mini">取消</el-button>
          <el-button type="primary" @click="updataCount" size="mini">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import selectcity from "@/components/Screening/selectcity";
import group from "./components/group.vue"
import { oldOrgList,moveOrg } from "@/api/move"
import { orgList , saveOrg , delOrg , findOrgAdmin , saveOrgAdmin,getGroupAdmin,saveGroupAdmin,delGroup,saveGroup } from "@/api/org"
export default {
  name:'org-manage',
  components:{
    selectcity,
    group
  },
  data() {
    return {
      activeName:'first',
      listQuery: {
        page: 1,
        limit: 10,
        name:'',
        credits: 0,
        status: 0,
      },
      //迁移
      listQuery1: {
        page: 1,
        limit: 10,
        name:'',
      },
      total: 0,
      total1: 1,
      list:[],
      list1: [],
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogAdminFormVisible: false,
      dialogAdminFormVisible1: false,
      dialogAdminFormVisible2: false,
      dialogCountFormVisible:false,
      dialogStatus: '',
      textMap: {
        update: '修改',
        create: '新增'
      },
      temp: {
        managerTel: '',
        name: '',
        manager: '',
        districtCode: '',
        address: '',
        logoUrl: '',
        groupId: 0
      },
      adminTemp: {
        cnName:"",
        userName: '',
        mobile:'',
        password: '',
      },
      adminGly: {
        cnName:"",
        userName: '',
        password: '',
        groupId: ''
      },
      adminXG: {
        id: 0,
        name:"",
      },
      countsTemp: {
        count: 0,
        countTime: "",
        countUseTime:'',
      },
      rules: {
        manager: [{ required: true, message: '请输入负责人', trigger: 'change' }],
        managerTel: [{ required: true, message: '请输入负责人电话', trigger: 'blur' }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        districtCode: [{ required: true, message: '请选择服务地址', trigger: 'blur' }]
      },
      orgId:''
    }
  },
  created() {
    this.contentStyleObj= this.$getHeight(290)
    this.contentStyleObj1= this.$getHeight(400)
    this.getList()
  },
  methods:{
    QYSJ(val) {
      console.log(val,'val')
    },
    getList(){
      orgList(this.listQuery).then(res=>{
        if(res.data.msg == "success"){
          this.list = res.data.data.list
          this.total = res.data.data.total
        }else{
          this.list = []
        }
      })
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    //迁移
    migration() {
      this.dialogFormVisible1 = true
      oldOrgList(this.listQuery1).then(res => {
        if(res.data.msg == 'success') {
          this.list1 = res.data.data.list
          this.total1 = res.data.data.total
        }
      })
    },
    resetTemp() {
      this.temp = {
        managerTel: '',
        name: '',
        manager: '',
        districtCode: [],
        address: '',
        type:'agent',
        logoUrl: ''
      }
    },
    handleClick(){
      if(this.activeName == 'second'){  
        this.listQuery.credits = 1
        this.getList()
      }else{
        this.listQuery.credits = 0
        this.getList()
      }
    },
    createData() {
      // this.$refs['dataForm'].validate((valid) => {
      //   console.log(valid);
      //   if (valid) {
          saveOrg(this.temp).then(res => {
            if(res.data.msg == 'success'){
              this.getList()
              this.dialogFormVisible = false
              this.$qzfMessage("创建成功")
            } 
          })
        // }
      // })
    },
    updateData() {
      // this.$refs['dataForm'].validate((valid) => {
        // if (valid) {
          saveOrg(this.temp).then(res => {
            if(res.data.msg == 'success'){
              this.getList()
              this.dialogFormVisible = false
              this.$qzfMessage("更新成功")
            }
          })
        // }
      // })
    },
    handleDelete(row){
      delOrg(row).then(res=>{
        if(res.data.msg == 'success'){
          this.getList()
          this.$qzfMessage("删除成功")
        }
      })
    },
    handleAdmin(row){
      findOrgAdmin({orgId:row.id}).then(res=>{
        if(res.data.msg == "success"){
          this.adminTemp = res.data.data.data
          this.adminTemp.orgId = row.id
          this.adminTemp.isAdmin = 1
        }
      })
      this.dialogAdminFormVisible = true
    },
    //集团账号管理
    handleGroup(row){
      getGroupAdmin({groupId:row.groupId}).then(res=>{
        if(res.data.msg == "success"){
          this.adminGly = res.data.data.info
          this.adminGly.groupId = row.groupId
        }
      })
      this.dialogAdminFormVisible1 = true
    },
    //修改
    handlemod(row) {
      this.dialogAdminFormVisible2 = true
      this.adminXG.name = row.groupName
      this.adminXG.id = row.groupId
    },
    //修改确认
    adminUpdateXG() {
      saveGroup(this.adminXG).then(res => {
        if(res.data.msg == 'success'){
          this.getList()
          this.$qzfMessage("修改成功")
          this.dialogAdminFormVisible2 = false
        }
      })
    },
    //删除
    handledel(row) {
      this.$confirm('你确定要删除该集团账号吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delGroup({id:row.groupId}).then(res=>{
          if(res.data.msg == 'success'){
            this.getList()
            this.$qzfMessage("删除成功")
          }
        })
      });
    },
    qianyi(row) {
      this.$confirm('你确定要迁移该账号吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        moveOrg({id:row.id}).then(res=>{
          if(res.data.msg == 'success'){
            this.migration()
            this.$qzfMessage("迁移成功")
          }
        })
      });
    },
    stopStatus(row){
      row.status = 3
      saveOrg(row).then(res => {
        if(res.data.msg == 'success'){
          this.getList()
          this.$qzfMessage("停用成功")
        }
      })
    },
    startStatus(row){
      row.status = 1
      saveOrg(row).then(res => {
        if(res.data.msg == 'success'){
          this.getList()
          this.$qzfMessage("启用成功")
        }
      })
    },
    adminUpdate(){
      saveOrgAdmin(this.adminTemp).then(res=>{
        if(res.data.msg == 'success'){
          this.dialogAdminFormVisible = false
          this.getList()
          this.$qzfMessage("操作成功")
        }
      })
    },
    //集团账号确认
    adminUpdateGLY() {
      saveGroupAdmin(this.adminGly).then(res=>{
        if(res.data.msg == 'success'){
          this.dialogAdminFormVisible1 = false
          this.getList()
          this.$qzfMessage("操作成功")
        }
      })
    },
    settingCount(row){
      //防止热更新(复制一份再修改)
      let copy = Object.assign({},row)
      this.countsTemp = copy
      this.dialogCountFormVisible = true
      this.countsTemp.id = copy.id
      if(row.countTime.match('0001')) {
        this.countsTemp.countTime = ''
      }
    },
    updataCount(){
      if(!this.countsTemp.count){
        this.$qzfMessage('账套个数不能为0',2);
        return
      }
      if(!this.countsTemp.countTime){
        this.$qzfMessage('请选择启用时间',2);
        return
      }
      let param = {
        id: this.countsTemp.id,
        count: this.countsTemp.count,
        countTime: this.countsTemp.countTime,
        countUseTime: this.countsTemp.countUseTime,
      }
      saveOrg(param).then(res => {
        if(res.data.msg == "success"){
          this.dialogCountFormVisible = false
          this.getList()
          this.$qzfMessage('修改成功');
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
// .el-table {
//   /deep/ th {
//     padding: 0px;
//   }
//   /deep/ td {
//     padding: 0px;
//   }
// }
.top_btns {
  margin-bottom: 10px;
  .left_search{
    float: left;
    width: 70%;
  }
  .right_btns {
    float: right;
    width: 30%;
    text-align: right;
  }
}
.el-input {
  width: 96%;
}
</style>